import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    backgroundColor: theme.palette.whitePepper.main,
  },

  container: {
    padding: '40px 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: '40px',

    [theme.breakpoints.up('sm')]: {
      padding: '50px',
    },

    [theme.breakpoints.up('md')]: {
      padding: '50px 75px 75px',
    },
  },
});
